import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ab10166&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6ab10166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab10166",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogHeader: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/header.vue').default,BlogBanner: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/banner.vue').default,BlogTopics: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/Topics.vue').default,BlogFeatured: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/Featured.vue').default,BlogFeaturedGrid: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/FeaturedGrid.vue').default,BlogSubscribe: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/Subscribe.vue').default})
